module.exports = __webpack_public_path__ + "img/cart-white2-bg.3a22dcd8.jpg";